import { UserManager, Log, MetadataService, User } from 'oidc-client'

class CognitoMetadataService extends MetadataService {
  async getEndSessionEndpoint () {
    var endSessionEndpoint = new URL(process.env.REACT_APP_AUTH_ENDPOINT)
    if (process.env.REACT_APP_LOGOUT_URI) {
      endSessionEndpoint = new URL(await this.getTokenEndpoint())
    }

    endSessionEndpoint.pathname = 'logout'
    endSessionEndpoint.searchParams.set(
      'client_id',
      process.env.REACT_APP_CLIENT_ID
    )

    const logoutUri =
      process.env.REACT_APP_LOGOUT_URI ||
      `${window.location.protocol}//${window.location.hostname}${
        window.location.port ? `:${window.location.port}` : ''
      }`

    endSessionEndpoint.searchParams.set('logout_uri', logoutUri)

    return endSessionEndpoint.href
  }
}

class CognitoUserManager extends UserManager {
  _signinStart (args, navigator, navigatorParams = {}) {
    Log.debug('_signinStart for Cognito')

    return navigator.prepare(navigatorParams).then(handle => {
      Log.debug('got navigator window handle')

      return this.createSigninRequest(args)
        .then(signinRequest => {
          Log.debug('got signin request')

          navigatorParams.url = signinRequest.url.replace('%20id_token', '')
          navigatorParams.id = signinRequest.state.id

          return handle.navigate(navigatorParams)
        })
        .catch(err => {
          if (handle.close) {
            Log.debug(
              'Error after preparing navigator, closing navigator window'
            )
            handle.close()
          }
          throw err
        })
    })
  }

  signinWithRefreshToken (refreshToken) {
    return this._tokenClient
      .exchangeRefreshToken({ refresh_token: refreshToken })
      .then(user => {
        const newUser = new User(this._manageClaims(user, refreshToken))
        return this.storeUser(newUser)
      })
  }

  _manageClaims (user, refreshToken) {
    const jwt = this._joseUtil.parseJwt(user.id_token).payload

    user.scope = this.settings.scope
    user.expires_at = jwt.exp
    user.refresh_token = refreshToken
    user.profile = jwt
    user.profile.username = jwt['cognito:username']

    delete user.profile.at_hash
    delete user.profile.aud
    delete user.profile.exp
    delete user.profile.iat
    delete user.profile.iss

    return user
  }
}

const createUserManager = settings => {
  const userManager = new CognitoUserManager({
    ...settings,
    clockSkew: 4500,
    MetadataServiceCtor: CognitoMetadataService
  })

  userManager.events.addSilentRenewError(e => {
    Log.debug('addSilentRenewError', e)

    setTimeout(() => {
      userManager.getUser()
    }, 2000)
  })

  userManager.events.addAccessTokenExpired(() => {
    Log.debug('addAccessTokenExpired')

    if (userManager.settings.automaticSilentRenew) {
      userManager.signinSilent().catch(error => Log.debug(error))
    }
  })

  return userManager
}

export default createUserManager



// WEBPACK FOOTER //
// ./src/Auth/createUserManager.js